export enum CustomEventTypes {
  SubscriptionEnrolmentInitiated = "AdvisorySubscriptionEnrolmentInitiated",
  AdvisorySubscriptionCropSelected = "AdvisorySubscriptionCropSelected",
  AdvisorySubscriptionDateOfSowingSelected = "AdvisorySubscriptionDateOfSowingSelected",
  AdvisorySubscriptionLocationAdded = "AdvisorySubscriptionLocationAdded",
  AdvisorySubscriptionCreated = "AdvisorySubscriptionCreated",
  LandedOnAdvisoryPage = "AdvisorySubscriptionUserLandedOnContentScreen",
  LandedonKhetEdgeHome = "AdvisorySubscriptionUserLandedonHome",
}
